import React, { useState } from "react";
import { EventBus } from "./eventBus";
import { generateId, formatDate, debounce } from "host/utils";

const MODIFY_TYPES = [
  { id: "1", label: "修改取车时间" },
  { id: "2", label: "修改还车时间" },
  { id: "3", label: "修改取车地点" },
  { id: "4", label: "修改还车地点" },
  { id: "5", label: "修改车辆类型" },
  { id: "6", label: "其他修改" },
];

const ModifyOrder: React.FC = () => {
  const [modifyType, setModifyType] = useState<string>("");
  const [modifyValue, setModifyValue] = useState<string>("");
  const [otherReason, setOtherReason] = useState<string>("");

  const debouncedEmit = debounce((value: string) => {
    if (value.trim()) {
      EventBus.emit("order-modify-message", {
        type: "modify-order-preview",
        previewValue: value,
      });
    }
  }, 500);

  const handleTypeChange = (typeId: string) => {
    setModifyType(typeId);
    setModifyValue("");
    if (typeId !== "6") {
      setOtherReason("");
    }
  };

  const handleConfirm = () => {
    if (!modifyType) {
      alert("请选择修改类型");
      return;
    }

    if (modifyType === "6") {
      if (!otherReason.trim()) {
        alert("请输入修改内容");
        return;
      }
    } else {
      if (!modifyValue.trim()) {
        alert("请输入修改内容");
        return;
      }
    }

    const typeLabel = MODIFY_TYPES.find((t) => t.id === modifyType)?.label;
    const value = modifyType === "6" ? otherReason : modifyValue;

    EventBus.emit("order-modify-message", {
      type: "modify-order",
      modifyType: modifyType,
      modifyTypeLabel: typeLabel,
      modifyValue: value,
      orderId: generateId(),
      modifyTime: formatDate(new Date()),
    });
  };

  return (
    <div style={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
      <h1 className="text-primary glow-text" style={{ marginBottom: "20px", fontSize: "20px", fontWeight: "bold" }}>修改订单</h1>
      <div style={{ marginBottom: "20px" }}>
        <div className="text-secondary" style={{ marginBottom: "12px", fontSize: "14px" }}>请选择修改类型：</div>
        {MODIFY_TYPES.map((type) => (
          <label
            key={type.id}
            className="glass-card"
            style={{
              display: "block",
              padding: "12px",
              marginBottom: "8px",
              cursor: "pointer",
              borderColor: modifyType === type.id ? "var(--color-border-glow)" : "var(--glass-border)",
            }}
          >
            <input
              type="radio"
              name="modifyType"
              value={type.id}
              checked={modifyType === type.id}
              onChange={(e) => handleTypeChange(e.target.value)}
              style={{ marginRight: "8px", accentColor: "var(--color-primary)" }}
            />
            <span className={modifyType === type.id ? "text-accent" : "text-secondary"}>{type.label}</span>
          </label>
        ))}
        {modifyType && modifyType !== "6" && (
          <input
            type="text"
            value={modifyValue}
            onChange={(e) => {
              setModifyValue(e.target.value);
              debouncedEmit(e.target.value);
            }}
            placeholder={`请输入${MODIFY_TYPES.find((t) => t.id === modifyType)?.label}`}
            className="glass-card"
            style={{
              width: "100%",
              padding: "8px",
              marginTop: "8px",
              fontSize: "14px",
              boxSizing: "border-box",
              color: "var(--color-text-primary)",
              background: "var(--glass-background)",
              borderColor: "var(--glass-border)",
            }}
          />
        )}
        {modifyType === "6" && (
          <textarea
            value={otherReason}
            onChange={(e) => {
              setOtherReason(e.target.value);
              debouncedEmit(e.target.value);
            }}
            placeholder="请输入修改内容"
            className="glass-card"
            style={{
              width: "100%",
              minHeight: "80px",
              padding: "8px",
              marginTop: "8px",
              fontSize: "14px",
              boxSizing: "border-box",
              color: "var(--color-text-primary)",
              background: "var(--glass-background)",
              borderColor: "var(--glass-border)",
            }}
          />
        )}
      </div>
      <button
        onClick={handleConfirm}
        className="btn-primary"
        style={{
          width: "100%",
        }}
      >
        确认修改
      </button>
    </div>
  );
};

export default ModifyOrder;

